module.exports = __webpack_public_path__ + "img/4.aed634f4.jpg";